/* Kainori : garde les cadeaux cohérents avec le nombre de dilatateurs dans le panier.
   Les cadeaux se cumulent par lot :
   Masque : 1 par tranche de 2 dilatateurs. Bouchons : 1 par tranche de 3 dilatateurs.
   (ex. lot de 3 + lot de 2 = 5 dilatateurs -> jusqu'à 2 masques et 1 paire de bouchons) */
(function () {
  var MAIN_VARIANT = 65417831350621;
  var GIFTS = [
    { id: 66350386020701, per: 2 },
    { id: 66350386250077, per: 3 }
  ];
  var busy = false;
  var timer = null;
  var originalFetch = window.fetch;

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = originalFetch.apply(this, arguments);
    if (!busy && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function (r) { if (r && r.ok) schedule(); }).catch(function () {});
    }
    return p;
  };

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 400);
  }

  function rerender(cd, secs, res) {
    secs.forEach(function (s) {
      var html = res.sections && res.sections[s.id];
      if (!html) return;
      var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      if (!el) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = doc.querySelector(s.selector || '.shopify-section');
      if (src) el.innerHTML = src.innerHTML;
    });
    if (res.item_count === 0) cd.classList.add('is-empty');
  }

  function sync() {
    if (busy) return;
    busy = true;
    originalFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var qty = 0;
        cart.items.forEach(function (it) { if (it.variant_id === MAIN_VARIANT) qty += it.quantity; });

        var updates = {};
        var changed = false;
        GIFTS.forEach(function (g) {
          var allowed = Math.floor(qty / g.per);
          cart.items.forEach(function (it) {
            if (it.variant_id !== g.id) return;
            var keep = Math.min(it.quantity, allowed);
            allowed -= keep;
            if (keep !== it.quantity) { updates[it.key] = keep; changed = true; }
          });
        });

        if (!changed) { busy = false; return; }

        var cd = document.querySelector('cart-drawer');
        var secs = cd && typeof cd.getSectionsToRender === 'function' ? cd.getSectionsToRender() : [];
        var body = { updates: updates };
        if (secs.length) {
          body.sections = secs.map(function (s) { return s.id; });
          body.sections_url = location.pathname;
        }

        return originalFetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (secs.length && res.sections) {
              rerender(cd, secs, res);
            } else if (/\/cart\/?$/.test(location.pathname)) {
              location.reload();
            }
            busy = false;
          });
      })
      .catch(function () { busy = false; });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
})();
